// extracted by mini-css-extract-plugin
export var filterIncDec = "_dp-0";
export var leftBorder = "_dp-1";
export var rightBorder = "_dp-2";
export var stringInput = "_dp-3";